// extracted by mini-css-extract-plugin
module.exports = {"cursor":"IconReviewStar_cursor__2TT-L","root":"IconReviewStar_root__2k5VF","filled":"IconReviewStar_filled__GR5J6"};